import { ref, provide, computed, openBlock, createElementBlock, renderSlot } from "vue";
/* empty css                  */
const _hoisted_1 = { class: "uikit-accordion" };
const _sfc_main = {
  __name: "Accordion",
  props: {
    defaultActiveTabId: {
      type: String,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const activePanelId = ref(props.defaultActiveTabId);
    const togglePanel = (panelId) => {
      activePanelId.value = activePanelId.value === panelId ? null : panelId;
    };
    provide("togglePanel", togglePanel);
    provide(
      "activePanelId",
      computed(() => activePanelId.value)
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "default")
      ]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=Accordion.vue.es.js.map
